import {
  MessageSquare,
  UserPlus,
  Eye,
  Clock,
  AlertTriangle,
  Info,
  CheckCircle,
  Lock,
  Building,
  Megaphone,
  Sparkles,
  Ticket,
  RefreshCw,
} from 'lucide-react';
import { NotificationType, isReminderNotification } from '../../types/notifications';

interface NotificationIconProps {
  type: NotificationType;
  className?: string;
}

/**
 * Renders an appropriate icon for a notification type
 */
export function NotificationIcon({ type, className = 'h-4 w-4' }: NotificationIconProps) {
  // Reminder notifications get warning colors
  if (isReminderNotification(type)) {
    switch (type) {
      case NotificationType.TicketReminderOverdue:
        return <AlertTriangle className={`${className} text-red-500`} />;
      case NotificationType.TicketReminder:
        return <Clock className={`${className} text-yellow-500`} />;
      default:
        return <Clock className={`${className} text-yellow-500`} />;
    }
  }

  // Standard notification types
  switch (type) {
    case NotificationType.TicketAssigned:
      return <Ticket className={`${className} text-blue-500`} />;
    case NotificationType.TicketComment:
      return <MessageSquare className={`${className} text-green-500`} />;
    case NotificationType.TicketStatusChanged:
      return <CheckCircle className={`${className} text-purple-500`} />;
    case NotificationType.TicketUpdated:
      return <RefreshCw className={`${className} text-blue-500`} />;
    case NotificationType.TicketCreated:
      return <Ticket className={`${className} text-blue-500`} />;
    case NotificationType.ParticipantAdded:
      return <UserPlus className={`${className} text-green-500`} />;
    case NotificationType.FollowerAdded:
      return <Eye className={`${className} text-blue-500`} />;
    case NotificationType.PasswordChanged:
      return <Lock className={`${className} text-purple-500`} />;
    case NotificationType.AccountLocked:
      return <Lock className={`${className} text-red-500`} />;
    case NotificationType.WelcomeMessage:
      return <Sparkles className={`${className} text-yellow-500`} />;
    case NotificationType.OrganizationInvite:
      return <Building className={`${className} text-blue-500`} />;
    case NotificationType.SystemAnnouncement:
      return <Megaphone className={`${className} text-blue-500`} />;
    case NotificationType.FeatureUpdate:
      return <Sparkles className={`${className} text-green-500`} />;
    case NotificationType.Info:
    default:
      return <Info className={`${className} text-gray-500`} />;
  }
}
